import { Options } from "../common/types/requestOptions";
import { api } from "./api";
import { CityAndCounty } from "../common/types/apiTypes";
import { WorkAgreementFormValues } from "../features/orders/editOrder/long/workAgreement/helpers";
import { SelectedTalent } from "../features/orders/types/editOrder";
import { TargetingKeys } from "../features/employment/targetedShiftSalaries/targetedShiftSalariesApi";

export type ReplaceWorkAgreementData = {
  formValues: WorkAgreementFormValues;
  talent: SelectedTalent;
  targetedShiftTargetingRules?: TargetingKeys[];
} | null;

export const listCitiesAndCounties = async ({ requestId }: Options) => {
  return api.get<CityAndCounty[]>("/projections/qry/citiesAndCounties", {
    requestId,
    auth: true,
  });
};
